import type {PathsIn} from '@logistics-frontend/utils'
import {identity} from '@logistics-frontend/utils'
import {formatOfferInterval as _formatOfferInterval} from '@yandex-delivery/form'

import {i18n} from '../config'
import type {Order as FormValues} from '../types'
import {toDate} from './date-time'
import {formatPrice} from './format-price'
import {formatSchedule, formatTime} from './format-schedule'
import {fromPaymentInfo} from './from-payment-info'
import {fromPinDropToPointAddress} from './from-pin-drop-to-point-address'
import {fromSddExpressProduct} from './from-sdd-express-product'
import {fromSuggestToPointAddress} from './from-suggest-to-point-address'
import {generateUniqueId} from './generate-unique-id'
import {getCoordinates, isValidCoordinates} from './get-coordinates'
import {getPointId} from './get-point-id'
import {getProducts} from './get-products'
import {mapVerticalToDeliveryType} from './map-vertical-to-delivery-type'
import {toDestinationPoint} from './to-destination-point'
import {toFiscalizaitonIfPaymentOnDemand} from './to-fiscalization-if-payment-on-demand'
import {toGeoLocation} from './to-geo-location'
import {toPaymentInfo} from './to-payment-info'
import {toPointAddress} from './to-point-address'
import {toPointContact} from './to-point-contact'

const formatOfferInterval = _formatOfferInterval(i18n)
const orderPath = identity as (p: PathsIn<FormValues>) => string

export {
  formatOfferInterval,
  formatPrice,
  formatSchedule,
  formatTime,
  fromPaymentInfo,
  fromPinDropToPointAddress,
  fromSddExpressProduct,
  fromSuggestToPointAddress,
  generateUniqueId,
  getCoordinates,
  getPointId,
  getProducts,
  isValidCoordinates,
  mapVerticalToDeliveryType,
  orderPath,
  toDate,
  toDestinationPoint,
  toFiscalizaitonIfPaymentOnDemand,
  toGeoLocation,
  toPaymentInfo,
  toPointAddress,
  toPointContact,
}
